<template>
	<div class="manual-paas-form">
		<TypographyTitle :level="3" class="pd-lg-x">{{ $t('paas.header') }}</TypographyTitle>
		<Card :bordered="false">
			<TypographyParagraph>
				{{ $t('paas.manualForm.hint') }}
				<router-link :to="{ name: 'stats-type', params: { id: 'coordinates-correction' } }">{{ $t('paas.manualForm.link') }}</router-link>
			</TypographyParagraph>
			<Space>
				<Button type="primary" @click="handleQuickMode" :loading="isLoading">{{ $t('paas.manualForm.quickModeButtonLabel') }}</Button>
				<Button type="primary" @click="handleFullMode" :loading="isLoading">{{ $t('paas.manualForm.fullModeButtonLabel') }}</Button>
			</Space>
		</Card>
	</div>
</template>

<script>
import { ref, toRef } from 'vue';
import { TypographyParagraph, Button, TypographyTitle, Space, Card, message } from 'ant-design-vue';
import { useI18n } from 'vue-i18n';

import ApiPaas from '@/api/ApiPaas';

import { showErrorMessage } from '@/components/common/errorMessage';

export default {
	components: {
		Button, TypographyParagraph, TypographyTitle, Space, Card,
	},
	props: ['baseStationId'],
	setup(props) {
		const { t } = useI18n();
		const isLoading = ref(false);
		const baseStationId = toRef(props, 'baseStationId');
		const handleClick = quickMode => () => {
			isLoading.value = true;
			ApiPaas.paasTaskAddManual(baseStationId.value, quickMode, response => {
				if (response.status === 'ok') {
					message.success(t('paas.manualForm.success'));
				} else {
					showErrorMessage(response.errors);
				}
				isLoading.value = false;
			});
		};
		const handleQuickMode = () => {
			handleClick(true)();
		};
		const handleFullMode = () => {
			handleClick(false)();
		};
		return {
			isLoading,
			handleQuickMode,
			handleFullMode,
		};
	},
};
</script>
<style scoped>
.manual-paas-form {
	margin: 0 0 1em;
}
</style>
